import React from 'react'
import styles from './DialogExit.module.css'
import IconClose from '../../../../../assets/icons/IconClose'

const DialogExit = ({
    onCancel,
    onExit,
    open,
}) => {
    return (
        <>
            {open ? <div className={styles.backDrop} onClick={onCancel}>
                <div className={styles.container} onClick={(e) => e.stopPropagation()}>
                    <IconClose onClick={onCancel} color={'white'} size={24} className={styles.buttonExit} />
                    <p className={styles.text}>Are you sure you want to exit? Progress won’t be saved</p>
                    <div className={styles.buttonsContainer}>
                        <p className={styles.button} onClick={onExit}>Exit</p>
                    </div>
                </div>
            </div> : null}
        </>
    )
}

export default DialogExit
